<template>
	<div id="allmap" class="allmap"></div>
</template>
<script>
    export default {
        name:'Map',
        data () {
            return {
				
            }
        },
        mounted() {
			var map = new BMap.Map("allmap") 
			var point = new BMap.Point(118.193417,24.495222) 
			map.centerAndZoom(point, 14)
			var marker = new BMap.Marker(point)  
			map.addOverlay(marker)
			map.addControl(new BMap.NavigationControl())    
			map.addControl(new BMap.ScaleControl())   
			map.addControl(new BMap.OverviewMapControl())
			map.enableScrollWheelZoom(true)
        }
    }
</script>
<style scoped>
	.allmap{
		width: 100%;
		height: 33rem;
	}
    @media screen and (max-width:472px) {
    	.allmap{
			width: 100%;
			height: 200px;
		}
    }
	@media screen and (min-width:992px){
		.allmap{
			width: 100%;
			height: 30.625rem;
		}
	}
</style>